import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import "react-phone-number-input/style.css";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import AuthService from "../../services/Auth.service";
import { useHistory} from "react-router-dom";
import Input from "../../components/Input/Input";

export default function Login() {
  const history = useHistory();
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown((prev) => !prev);
  };

  // Validation schema
  const formSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const validationOpt = {
    resolver: yupResolver(formSchema),
    defaultValues: { rememberMe: false },
  };

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setError,
    reset,
  } = useForm(validationOpt);


  const onSubmit = async (formData) => {
    try {
      const response = await AuthService.login({
        email: formData.email,
        password: formData.password,
      });

      if (response.status === 200) {
        localStorage.setItem("user", JSON.stringify(response.data));
        history.push("/dashboard");
      } else {
        setError("apiError", { message: "Unexpected response from server" });
      }
    } catch (error) {
        setError("apiError", { message: error.response.data.detail });
    }
  };

  var currentYear = new Date().getFullYear();

  return (
    <React.Fragment>
      <div className="warrper">
        <div className="login-box">
          <div className="container-lg">
            <div className="login-detail">
              <div className="left-box">
                <img src="/assets/images/login-banner.png" alt="login-banner" />
              </div>

              <div className="right-box">
                <div className="right-box-detail">
                  <img src="/assets/images/logo.png" alt="logo" />

                  <form onSubmit={handleSubmit(onSubmit)} className="login-form">
                    {/* Email Field */}
                    <Controller
                      control={control}
                      name="email"
                      render={({ field: { onChange, value } }) => (
                        <Input
                          placeholder="Enter Your Email"
                          onChange={onChange}
                          value={value || ""}
                          type="text"
                          errorClass={errors.email}
                          errorMessage={errors.email?.message}
                        />
                      )}
                    />

                    {/* Password Field */}
                    <div style={{ position: "relative" }}>
                      <Controller
                        control={control}
                        name="password"
                        render={({ field: { onChange, value } }) => (
                          <Input
                            placeholder="Enter Password"
                            onChange={onChange}
                            value={value || ""}
                            type={passwordShown ? "text" : "password"}
                            errorClass={errors.password}
                            errorMessage={errors.password?.message}
                          />
                        )}
                      />
                      <i
                        className="fa fa-eye"
                        onClick={togglePasswordVisiblity}
                        style={{
                          position: "absolute",
                          right: "0",
                          bottom: "11px",
                          cursor: "pointer",
                        }}
                        aria-hidden="true"
                      ></i>
                    </div>

                    {/* API Error */}
                    {errors.apiError && (
                      <div className="alert alert-danger mt-3 mb-0">
                        {errors.apiError?.message}
                      </div>
                    )}

                    {/* Login Button */}
                    <div className="button-box">
                      <button
                        disabled={isSubmitting}
                        className="btn login-btn red-btn responshiv"
                      >
                        Login
                      </button>
                    </div>
                  </form>

                  {/* Footer */}
                  <div className="copy-rightbox">
                    <p>Copyright ValuEnable ©{currentYear} . All Rights Reserved</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
